import { Area, AreaChart as RechartsAreaChart, Tooltip, XAxis } from 'recharts';

import { ChartContainer } from '@/components/charts/ChartContainer';

export function AreaChart({
  data,
}: {
  data: Record<string, string | number>[];
}) {
  return (
    <ChartContainer>
      <RechartsAreaChart
        data={data}
        margin={{
          top: 4,
          right: 0,
          left: 0,
          bottom: 0,
        }}
      >
        <Tooltip
          content={<CustomTooltip />}
          cursor={{ className: 'fill-chariot-background-secondary' }}
        />
        <Area
          type="basis"
          dataKey="count"
          className="[&_path:nth-child(1)]:fill-chariot-brand-primary [&_path]:stroke-chariot-brand-primary"
          fillOpacity={1}
        />
        <XAxis
          dataKey="name"
          interval={10}
          minTickGap={40}
          className="[&>line]:stroke-chariot-stroke [&_tspan]:fill-chariot-text-secondary text-xs font-normal"
          tickLine={false}
          strokeWidth={2}
          hide
        />
      </RechartsAreaChart>
    </ChartContainer>
  );
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const CustomTooltip = ({ active, payload, label }: any) => {
  if (active && payload && payload.length) {
    return (
      <div className="border-chariot-stroke bg-chariot-background-primary text-chariot-text-primary mx-2 rounded-md border-2 px-2 py-px">
        {/* eslint-disable-next-line @typescript-eslint/no-explicit-any */}
        {(payload as any[]).map((entry, index) => {
          return (
            <p key={`item-${index}`} className="text-chariot-text-primary">
              {label}: {Math.abs(entry.value || 0)}
            </p>
          );
        })}
      </div>
    );
  }
  return null;
};
